import { render, staticRenderFns } from "./OzPadletLogo.vue?vue&type=template&id=bfc4722e&scoped=true&"
import script from "./OzPadletLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzPadletLogo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OzPadletLogo.vue?vue&type=style&index=0&id=bfc4722e&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc4722e",
  null
  
)

export default component.exports